/* Ankuendigungsleiste: setzt die Leiste an den Anfang des Headers.
   Optionaler Aktions-Timer fuer [data-aw-sale] (sections/banner.liquid). */
(function () {
  function moveIntoHeader() {
    var bar = document.querySelector('[data-wb-bar]');
    var header = document.getElementById('header-component');
    if (!bar || !header) return false;
    if (bar.dataset.wbMoved) return true;
    header.insertBefore(bar, header.firstChild);
    bar.dataset.wbMoved = '1';
    return true;
  }

  var KEY = 'aw_sale_until';
  var KEY_TOTAL = 'aw_sale_total';

  function lies(key) {
    try { return parseInt(sessionStorage.getItem(key), 10) || 0; } catch (e) { return 0; }
  }
  function schreib(key, wert) {
    try { sessionStorage.setItem(key, String(wert)); } catch (e) {}
  }
  function zwei(n) { return (n < 10 ? '0' : '') + n; }

  function saleTimer() {
    var bar = document.querySelector('[data-aw-sale]');
    if (!bar || bar.dataset.awSaleOn) return;
    bar.dataset.awSaleOn = '1';

    var until = lies(KEY);
    var total = lies(KEY_TOTAL);
    if (!until || !total) {
      var min = parseFloat(bar.dataset.min) || 158;
      var max = parseFloat(bar.dataset.max) || 178;
      if (max < min) max = min;
      total = Math.floor(min * 60 + Math.random() * (max - min) * 60);
      until = Date.now() + total * 1000;
      schreib(KEY, until);
      schreib(KEY_TOTAL, total);
    }

    var felder = {
      h: bar.querySelector('[data-k="h"]'),
      m: bar.querySelector('[data-k="m"]'),
      s: bar.querySelector('[data-k="s"]')
    };
    var linie = bar.querySelector('[data-aw-linie]');
    var sub = bar.querySelector('[data-aw-sub]');
    var iv = null;
    var erst = true;

    function setze(el, wert) {
      if (!el || el.textContent === wert) return;
      el.textContent = wert;
      if (erst) return;
      el.classList.remove('is-neu');
      void el.offsetWidth;
      el.classList.add('is-neu');
    }

    function tick() {
      var left = Math.max(0, Math.round((until - Date.now()) / 1000));
      if (left <= 0) {
        bar.classList.add('is-vorbei');
        if (sub && bar.dataset.vorbei) sub.textContent = bar.dataset.vorbei;
        if (iv) clearInterval(iv);
        return;
      }
      setze(felder.h, zwei(Math.floor(left / 3600)));
      setze(felder.m, zwei(Math.floor((left % 3600) / 60)));
      setze(felder.s, zwei(left % 60));
      if (linie) linie.style.width = Math.min(100, (left / total) * 100).toFixed(2) + '%';
      erst = false;
    }

    tick();
    bar.classList.add('is-ready');
    if (!bar.classList.contains('is-vorbei')) iv = setInterval(tick, 1000);
  }

  function start() {
    saleTimer();
    var tries = 0;
    (function retry() {
      if (moveIntoHeader() || ++tries > 40) return;
      setTimeout(retry, 150);
    })();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
